export const SET_USER_SETTINGS = 'setUserSettings';